<ng-container *ngIf="chartOptions">
  <span *ngIf="showTitle" class="title">Cash Flow History</span>

  <div id="chart">
    <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis" [dataLabels]="chartOptions.dataLabels" [colors]="chartOptions.colors"
      [legend]="chartOptions.legend" [fill]="chartOptions.fill" [stroke]="chartOptions.stroke"
      [grid]="chartOptions.grid" [tooltip]="chartOptions.tooltip" [responsive]="chartOptions.responsive"></apx-chart>
  </div>
</ng-container>
